import React from "react";
import Aside from "./Aside";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import Extras from "./Extras";

function MasterLayouts() {
  return (
    <>
  {/*begin::App*/}
  <div
    className="d-flex flex-column flex-root app-root"
    id="kt_app_root"
    data-select2-id="select2-data-kt_app_root"
  >
    {/*begin::Page*/}
    <div
      className="app-page  flex-column flex-column-fluid "
      id="kt_app_page"
      data-select2-id="select2-data-kt_app_page"
    >
      {/*begin::Wrapper*/}
      <div
        className="app-wrapper  flex-column flex-row-fluid "
        id="kt_app_wrapper"
        data-select2-id="select2-data-kt_app_wrapper"
      >
        <Aside />
        {/*begin::Main*/}
        <div
          className="app-main flex-column flex-row-fluid "
          id="kt_app_main"
          data-select2-id="select2-data-kt_app_main"
        >
          {/*begin::Content wrapper*/}
          <div
            className="d-flex flex-column flex-column-fluid"
            data-select2-id="select2-data-135-7n7j"
          >
            <Outlet />
          </div>
          {/*end::Content wrapper*/}
          <Footer />
        </div>
        {/*end:::Main*/}
      </div>
      {/*end::Wrapper*/}
    </div>
    {/*end::Page*/}
  </div>
  {/*end::App*/}

  {/*begin::Scrolltop*/}
  <div id="kt_scrolltop" className="scrolltop" data-kt-scrolltop="true">
    <i className="ki-duotone ki-arrow-up">
      <span className="path1" />
      <span className="path2" />
    </i>
  </div>
  {/*end::Scrolltop*/}
</>

  );
}

export default MasterLayouts;
